var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4147 15.5905C19.401 20.5755 20.5322 14.8084 23.7071 17.981C26.7678 21.0409 28.527 21.654 24.649 25.5309C24.1633 25.9213 21.077 30.6178 10.2308 19.7746C-0.616848 8.93 4.07698 5.84056 4.46746 5.35494C8.35483 1.46731 8.95733 3.23673 12.0181 6.29666C15.193 9.47062 9.42832 10.6055 14.4147 15.5905Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall2);
export default __webpack_public_path__ + "static/media/Call 2.e998984a.svg";
export { ForwardRef as ReactComponent };